export interface KeywordResearchLocaleOption {
  value: string;
  label: string;
}

export const keywordResearchMarketplaces: KeywordResearchLocaleOption[] = [
  { value: 'ad', label: 'Andorra (AD)' },
  { value: 'al', label: 'Albania (AL)' },
  { value: 'at', label: 'Austria (AT)' },
  { value: 'ba', label: 'Bosnia and Herzegovina (BA)' },
  { value: 'be', label: 'Belgium (BE)' },
  { value: 'bg', label: 'Bulgaria (BG)' },
  { value: 'ch', label: 'Switzerland (CH)' },
  { value: 'cy', label: 'Cyprus (CY)' },
  { value: 'cz', label: 'Czech Republic (CZ)' },
  { value: 'de', label: 'Germany (DE)' },
  { value: 'dk', label: 'Denmark (DK)' },
  { value: 'ee', label: 'Estonia (EE)' },
  { value: 'es', label: 'Spain (ES)' },
  { value: 'fi', label: 'Finland (FI)' },
  { value: 'fr', label: 'France (FR)' },
  { value: 'gi', label: 'Gibraltar (GI)' },
  { value: 'gr', label: 'Greece (GR)' },
  { value: 'hr', label: 'Croatia (HR)' },
  { value: 'hu', label: 'Hungary (HU)' },
  { value: 'ie', label: 'Ireland (IE)' },
  { value: 'is', label: 'Iceland (IS)' },
  { value: 'it', label: 'Italy (IT)' },
  { value: 'li', label: 'Liechtenstein (LI)' },
  { value: 'lt', label: 'Lithuania (LT)' },
  { value: 'lu', label: 'Luxembourg (LU)' },
  { value: 'lv', label: 'Latvia (LV)' },
  { value: 'mc', label: 'Monaco (MC)' },
  { value: 'md', label: 'Moldova (MD)' },
  { value: 'me', label: 'Montenegro (ME)' },
  { value: 'mk', label: 'North Macedonia (MK)' },
  { value: 'mt', label: 'Malta (MT)' },
  { value: 'nl', label: 'Netherlands (NL)' },
  { value: 'no', label: 'Norway (NO)' },
  { value: 'pl', label: 'Poland (PL)' },
  { value: 'pt', label: 'Portugal (PT)' },
  { value: 'ro', label: 'Romania (RO)' },
  { value: 'rs', label: 'Serbia (RS)' },
  { value: 'se', label: 'Sweden (SE)' },
  { value: 'si', label: 'Slovenia (SI)' },
  { value: 'sk', label: 'Slovakia (SK)' },
  { value: 'sm', label: 'San Marino (SM)' },
  { value: 'tr', label: 'Turkey (TR)' },
  { value: 'ua', label: 'Ukraine (UA)' },
  { value: 'uk', label: 'United Kingdom (UK)' },
  { value: 'us', label: 'United States (US)' },
  { value: 'xk', label: 'Kosovo (XK)' },
];

export const keywordResearchLanguages: KeywordResearchLocaleOption[] = [
  { value: 'bg', label: 'Bulgarian (bg)' },
  { value: 'bs', label: 'Bosnian (bs)' },
  { value: 'ca', label: 'Catalan (ca)' },
  { value: 'cs', label: 'Czech (cs)' },
  { value: 'cy', label: 'Welsh (cy)' },
  { value: 'da', label: 'Danish (da)' },
  { value: 'de', label: 'German (de)' },
  { value: 'el', label: 'Greek (el)' },
  { value: 'en', label: 'English (en)' },
  { value: 'es', label: 'Spanish (es)' },
  { value: 'et', label: 'Estonian (et)' },
  { value: 'eu', label: 'Basque (eu)' },
  { value: 'fi', label: 'Finnish (fi)' },
  { value: 'fr', label: 'French (fr)' },
  { value: 'ga', label: 'Irish (ga)' },
  { value: 'gl', label: 'Galician (gl)' },
  { value: 'hr', label: 'Croatian (hr)' },
  { value: 'hu', label: 'Hungarian (hu)' },
  { value: 'is', label: 'Icelandic (is)' },
  { value: 'it', label: 'Italian (it)' },
  { value: 'lb', label: 'Luxembourgish (lb)' },
  { value: 'lt', label: 'Lithuanian (lt)' },
  { value: 'lv', label: 'Latvian (lv)' },
  { value: 'mk', label: 'Macedonian (mk)' },
  { value: 'mt', label: 'Maltese (mt)' },
  { value: 'nl', label: 'Dutch (nl)' },
  { value: 'no', label: 'Norwegian (no)' },
  { value: 'pl', label: 'Polish (pl)' },
  { value: 'pt', label: 'Portuguese (pt)' },
  { value: 'rm', label: 'Romansh (rm)' },
  { value: 'ro', label: 'Romanian (ro)' },
  { value: 'ru', label: 'Russian (ru)' },
  { value: 'sk', label: 'Slovak (sk)' },
  { value: 'sl', label: 'Slovenian (sl)' },
  { value: 'sq', label: 'Albanian (sq)' },
  { value: 'sr', label: 'Serbian (sr)' },
  { value: 'sv', label: 'Swedish (sv)' },
  { value: 'tr', label: 'Turkish (tr)' },
  { value: 'uk', label: 'Ukrainian (uk)' },
];

export const keywordResearchLocalePairs: Record<string, string[]> = {
  ad: ['ca'],
  al: ['sq'],
  at: ['de'],
  ba: ['bs', 'hr', 'sr'],
  be: ['de', 'fr', 'nl'],
  bg: ['bg'],
  ch: ['de', 'fr', 'it', 'rm'],
  cy: ['el', 'tr'],
  cz: ['cs'],
  de: ['de'],
  dk: ['da'],
  ee: ['et', 'ru'],
  es: ['ca', 'es', 'eu', 'gl'],
  fi: ['fi', 'sv'],
  fr: ['fr'],
  gi: ['en'],
  gr: ['el'],
  hr: ['hr'],
  hu: ['hu'],
  ie: ['en', 'ga'],
  is: ['is'],
  it: ['it'],
  li: ['de'],
  lt: ['lt', 'ru'],
  lu: ['de', 'fr', 'lb'],
  lv: ['lv', 'ru'],
  mc: ['fr'],
  md: ['ro', 'ru'],
  me: ['bs', 'hr', 'sq', 'sr'],
  mk: ['mk'],
  mt: ['en', 'mt'],
  nl: ['nl'],
  no: ['no'],
  pl: ['pl'],
  pt: ['pt'],
  ro: ['ro'],
  rs: ['sr'],
  se: ['sv'],
  si: ['sl'],
  sk: ['sk'],
  sm: ['it'],
  tr: ['tr'],
  ua: ['ru', 'uk'],
  uk: ['cy', 'en'],
  us: ['en'],
  xk: ['sq', 'sr'],
};

const preferredMarketplaceByLanguage: Record<string, string> = {
  bg: 'bg',
  bs: 'ba',
  ca: 'es',
  cs: 'cz',
  cy: 'uk',
  da: 'dk',
  de: 'de',
  el: 'gr',
  en: 'uk',
  es: 'es',
  et: 'ee',
  eu: 'es',
  fi: 'fi',
  fr: 'fr',
  ga: 'ie',
  gl: 'es',
  hr: 'hr',
  hu: 'hu',
  is: 'is',
  it: 'it',
  lb: 'lu',
  lt: 'lt',
  lv: 'lv',
  mk: 'mk',
  mt: 'mt',
  nl: 'nl',
  no: 'no',
  pl: 'pl',
  pt: 'pt',
  rm: 'ch',
  ro: 'ro',
  ru: 'ua',
  sk: 'sk',
  sl: 'si',
  sq: 'al',
  sr: 'rs',
  sv: 'se',
  tr: 'tr',
  uk: 'ua',
};

export const normalizeLocaleCode = (value?: string): string => (
  (value || '').trim().toLowerCase().replace('_', '-')
);

export const getLanguageOptionsForMarketplace = (marketplace?: string) => {
  const marketplaceCode = normalizeLocaleCode(marketplace);
  const supportedLanguages = keywordResearchLocalePairs[marketplaceCode];
  if (!supportedLanguages) return keywordResearchLanguages;
  const supportedLanguageSet = new Set(supportedLanguages);
  return keywordResearchLanguages.filter((option) => supportedLanguageSet.has(option.value));
};

export const isSupportedKeywordResearchLocale = (
  marketplace?: string,
  language?: string,
): boolean => {
  const marketplaceCode = normalizeLocaleCode(marketplace);
  const languageCode = normalizeLocaleCode(language);
  return Boolean(keywordResearchLocalePairs[marketplaceCode]?.includes(languageCode));
};

export const getMarketplaceOptionsForLanguage = (language?: string) => {
  const languageCode = normalizeLocaleCode(language);
  if (!languageCode) return keywordResearchMarketplaces;
  const supportedMarketplaceSet = new Set(
    Object.entries(keywordResearchLocalePairs)
      .filter(([, languages]) => languages.includes(languageCode))
      .map(([marketplace]) => marketplace),
  );
  return keywordResearchMarketplaces.filter((option) => supportedMarketplaceSet.has(option.value));
};

export const getPreferredMarketplaceForLanguage = (language?: string): string | undefined => {
  const languageCode = normalizeLocaleCode(language);
  const preferredMarketplace = preferredMarketplaceByLanguage[languageCode];
  if (preferredMarketplace && isSupportedKeywordResearchLocale(preferredMarketplace, languageCode)) {
    return preferredMarketplace;
  }
  return getMarketplaceOptionsForLanguage(languageCode)[0]?.value;
};
